import { Community } from '@quick/client';
import React, { useState } from 'react';
import { Button, Dropdown, Menu } from 'antd';
import { useJoinedCommunitiesQuery } from '../../hooks/Community';
import { DownOutlined, PlusOutlined } from '@ant-design/icons';
import OnboardingModal from './onboarding/OnboardingModal';
import CommunityInfoOverview from './components/CommunityInfoOverview';
import AvatarStatus from '../../components/shared-components/AvatarStatus';
import { Link } from 'react-router-dom';
import { communityPrefixPath } from '../../hooks/Routing';
import { useCurrentCommunityId } from '../../redux/selector';

const MENU_ITEM_HEIGHT = 64;

const CommunitySwitcher: React.FC = () => {
  const joinedCommunities = useJoinedCommunitiesQuery().data ?? [];
  joinedCommunities.sort(compareCommunityName);
  const currentCommunityId = useCurrentCommunityId();
  const currentCommunity = joinedCommunities.find((it) => it.communityId === currentCommunityId);
  const [onboardingModalVisible, setOnboardingModalVisible] = useState(false);
  if (joinedCommunities.length === 0 || !currentCommunity) {
    return <></>;
  }
  const menuItems = [
    ...joinedCommunities.map((community) => {
      return (
        <Menu.Item
          key={menuKey(community)}
          className="d-flex flex-column align-items-start justify-content-center"
          style={{ height: MENU_ITEM_HEIGHT }}
        >
          <Link to={`${communityPrefixPath(community.communityId)}`}>
            <CommunityInfoOverview community={community} />
          </Link>
        </Menu.Item>
      );
    }),
    // HOA-1099 Temporarily hide onboarding flow.
    // <Menu.Item
    //   key={-1}
    //   className="d-flex flex-column align-items-start justify-content-center px-4"
    //   style={{ height: MENU_ITEM_HEIGHT }}
    //   onClick={() => {
    //     setOnboardingModalVisible(true);
    //   }}
    // >
    //   <div className="d-flex align-items-center">
    //     <AvatarStatus
    //       icon={<PlusOutlined className="font-size-label-l" />}
    //       type="primary"
    //       name={<span className="label-s">Add communities</span>}
    //     />
    //   </div>
    // </Menu.Item>,
  ];
  const profileMenu = (
    <Menu selectable={false} selectedKeys={[menuKey(currentCommunity)]} className="nav-dropdown">
      {menuItems}
    </Menu>
  );
  return (
    <>
      <Dropdown placement="bottomRight" overlay={profileMenu}>
        <Button
          className="pl-1 pr-2 w-100 d-flex flex-shrink-1 align-items-center"
          type="text"
          size="large"
          style={{ minWidth: 0 }}
        >
          {currentCommunity && <CommunityInfoOverview community={currentCommunity} hideAddress={true} />}
          <DownOutlined className="ml-2" />
        </Button>
      </Dropdown>
      {/* Modal should be outside of the dropdown. Otherwise it prevents the menu from closing properly. */}
      <OnboardingModal visible={onboardingModalVisible} onClose={() => setOnboardingModalVisible(false)} />
    </>
  );
};

const menuKey = (communityId: Community | undefined) => {
  return `c-${communityId?.communityId}`;
};

const compareCommunityName = (a: Community, b: Community) => {
  return a.name.localeCompare(b.name);
};

export default CommunitySwitcher;
